import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'

import { CompleteResetPasswordPayload, RequestResetPasswordPayload } from './types'

export const requestResetPassword = async (values: RequestResetPasswordPayload) => {
  return wretchClient
    .url('/admin/1.0/operators/reset-password/init')
    .post(values)
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const completeResetPassword = async (values: CompleteResetPasswordPayload) => {
  return wretchClient
    .url('/admin/1.0/operators/reset-password/finish')
    .post(values)
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
